"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const index_1 = require("../index");
function GroupEditPopupCommon({ group, onSaveInfo, isCreation = false, isSaved, setIsSaved, }) {
    const [selectedTab, setSelectedTab] = (0, react_1.useState)(0);
    const [currentGroupInfo, setCurrentGroupInfo] = (0, react_1.useState)(group);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const onSelectTabCallback = (tab) => () => {
        setSelectedTab(tab);
    };
    (0, react_1.useEffect)(() => {
        if (isSaved) {
            setIsLoading(false);
        }
    }, [isSaved]);
    const onSave = (groupInfo) => __awaiter(this, void 0, void 0, function* () {
        setIsLoading(true);
        const updatedGroupData = yield onSaveInfo(groupInfo);
        if (updatedGroupData) {
            setCurrentGroupInfo(updatedGroupData);
        }
        // @ts-ignore
        if (isCreation && window.accessController.hasSharingPermission) {
            setSelectedTab(1);
        }
    });
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'GroupEditPopupCommon_Container', children: [(0, jsx_runtime_1.jsxs)(Header, { "data-e2e": 'GroupEditPopupCommon_Header', children: [(0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'GroupEditPopupCommon_Title', children: isCreation
                            ? (0, i18n_1.Localized)(i18n_1.Strings.groups.edit.new)
                            : (0, i18n_1.Localized)(i18n_1.Strings.groups.edit.edit) }), 
                    // @ts-ignore - TODO replace with licenses service
                    window.accessController.hasSharingPermission && ((0, jsx_runtime_1.jsxs)(Tabs, { "data-e2e": 'GroupEditPopupCommon_Tabs', children: [(0, jsx_runtime_1.jsx)(Tab, { selected: selectedTab === 0, onClick: onSelectTabCallback(0), "data-e2e": 'GroupEditPopupCommon_Tab', children: (0, i18n_1.Localized)(i18n_1.Strings.groups.edit.profileTab) }), (0, jsx_runtime_1.jsx)(Tab, { selected: selectedTab === 1, onClick: onSelectTabCallback(1), "data-e2e": 'GroupEditPopupCommon_Tab', children: (0, i18n_1.Localized)(i18n_1.Strings.groups.edit.membersTab) })] }))] }), (0, jsx_runtime_1.jsx)(Content, { "data-e2e": 'GroupEditPopupCommon_Content', children: selectedTab === 0 ? ((0, jsx_runtime_1.jsx)(index_1.GroupEditInfo, { group: group, currentGroupInfo: currentGroupInfo, onSave: onSave, isEdit: !!(group === null || group === void 0 ? void 0 : group.name), setGroupInfo: setCurrentGroupInfo, isLoading: isLoading, isSaved: isSaved, setIsSaved: setIsSaved, "data-e2e": 'GroupEditPopupCommon_GroupEditInfo' })) : ((0, jsx_runtime_1.jsx)(index_1.GroupEditMembers, { group: group, "data-e2e": 'GroupEditPopupCommon_GroupEditMembers' })) })] }));
}
exports.default = GroupEditPopupCommon;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;

  width: 800px;
  height: 60vh;
  min-height: 600px;
  max-height: 90vh;

  overflow: hidden;

  background-color: ${props => props.theme.backgroundSenary};
`;
const Header = styled_components_1.default.div `
  display: flex;
  flex-direction: column;

  color: ${props => props.theme.white};

  background-color: ${props => props.theme.green};
`;
const Title = styled_components_1.default.div `
  padding: 10px 0;

  font-size: 18px;
  text-align: center;
`;
const Tabs = styled_components_1.default.div `
  display: flex;

  width: 100%;
  height: ${props => props.theme.headerHeight}px;
`;
const Tab = (0, styled_components_1.default)(ui_1.BaseButton) `
  width: 50%;
  height: 100%;

  color: ${props => props.theme.white};

  font-size: 14px;

  border-bottom: 4px solid
    ${props => (props.selected ? props.theme.white : 'transparent')};

  cursor: pointer;

  opacity: ${props => (props.selected ? 1 : 0.6)};
`;
const Content = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  width: 100%;

  overflow: hidden;
`;
